/* On-brand menu: mega-menu op desktop (hover op categorie) + nieuwe inhoud in de mobiele drawer. */
(function () {
  var DESK = window.matchMedia('(min-width: 990px)');

  /* ---------- desktop mega-menu ---------- */
  function initMega() {
    var mega = document.querySelector('[data-lx-mega]');
    if (!mega) return;
    document.body.appendChild(mega);
    var panels = {};
    mega.querySelectorAll('[data-lx-panel]').forEach(function (p) { panels[p.getAttribute('data-lx-panel')] = p; });
    var header = document.querySelector('sticky-header, .header-wrapper, header');
    var hideTimer = null, activeLink = null;

    function place() {
      var r = (header || document.body).getBoundingClientRect();
      mega.style.top = Math.max(0, r.bottom) + 'px';
    }
    function show(path, link) {
      if (!DESK.matches || !panels[path]) return;
      clearTimeout(hideTimer);
      Object.keys(panels).forEach(function (k) { panels[k].hidden = k !== path; });
      if (activeLink) activeLink.classList.remove('lx-nav-on');
      activeLink = link; link.classList.add('lx-nav-on');
      place(); mega.hidden = false;
      requestAnimationFrame(function () { mega.classList.add('lx-open'); });
    }
    function hideSoon() {
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        mega.classList.remove('lx-open');
        if (activeLink) activeLink.classList.remove('lx-nav-on');
        setTimeout(function () { if (!mega.classList.contains('lx-open')) mega.hidden = true; }, 180);
      }, 140);
    }
    function bind() {
      document.querySelectorAll('header a[href]').forEach(function (a) {
        if (a.closest('.menu-drawer') || a.dataset.lxBound) return;
        var path = a.getAttribute('href').split('?')[0];
        if (!panels[path]) return;
        a.dataset.lxBound = '1';
        a.addEventListener('mouseenter', function () { show(path, a); });
        a.addEventListener('mouseleave', hideSoon);
        a.addEventListener('focus', function () { show(path, a); });
      });
    }
    mega.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
    mega.addEventListener('mouseleave', hideSoon);
    window.addEventListener('scroll', function () { if (!mega.hidden) place(); }, { passive: true });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hideSoon(); });
    bind();
    new MutationObserver(bind).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- mobiele drawer ---------- */
  function fillDrawer() {
    var tpl = document.getElementById('lx-mobile-menu');
    var box = document.querySelector('.menu-drawer__navigation-container');
    if (!tpl || !box || box.querySelector('.lx-mm')) return;
    box.classList.add('lx-mm-host');
    box.appendChild(tpl.content.firstElementChild.cloneNode(true));
  }

  function sizeDrawer() {
    var d = document.querySelector('.menu-drawer');
    if (!d) return;
    var top = d.getBoundingClientRect().top;
    if (top > 0 && top < window.innerHeight) {
      d.style.height = (window.innerHeight - top) + 'px';
      d.classList.add('lx-mm-sized');
    }
  }

  function start() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('.header__icon--menu')) setTimeout(sizeDrawer, 350);
    });
    window.addEventListener('resize', sizeDrawer);
    initMega();
    fillDrawer();
    new MutationObserver(fillDrawer).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
